import React, { useState, useEffect } from "react";

export default function AttributeFilterBar({
  attributes = [],
  filters,
  setFilters,
  fetchValues, // ✅ NEW
}) {
  const [selectedAttr, setSelectedAttr] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const [values, setValues] = useState([]); // ✅ NEW

  // ✅ LOAD VALUES WHEN ATTRIBUTE CHANGES
  useEffect(() => {
    if (selectedAttr) {
      fetchValues(selectedAttr, setValues);
    } else {
      setValues([]);
    }
  }, [selectedAttr]);

  const handleAdd = () => {
    if (!selectedAttr || !selectedValue) return;

    const attr = attributes.find((a) => a.id == selectedAttr);

    if (!attr) return;

    setFilters((prev) => [
      ...prev,
      {
        attribute_id: attr.id,
        attribute_name: attr.attribute_code,
        label: attr.attribute_name,
        value: selectedValue,
      },
    ]);

    setSelectedAttr("");
    setSelectedValue("");
    setValues([]); // reset values
  };

  const removeFilter = (index) => {
    setFilters((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Add Filter Row */}
      <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
        {/* ATTRIBUTE DROPDOWN */}
        <select
          className="form-select"
          style={{ maxWidth: 200 }}
          value={selectedAttr}
          onChange={(e) => {
            setSelectedAttr(e.target.value);
            setSelectedValue("");
          }}
        >
          <option value="">Select Attribute</option>
          {attributes.map((a) => (
            <option key={a.id} value={a.id}>
              {a.attribute_name}
            </option>
          ))}
        </select>

        {/* VALUE DROPDOWN */}
        <select
          className="form-select"
          style={{ maxWidth: 200 }}
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
          disabled={!selectedAttr}
        >
          <option value="">Select Value</option>

          {values.map((v, i) => (
            <option key={i} value={v.value}>
              {v.value}
            </option>
          ))}
        </select>

        <button className="btn btn-primary" onClick={handleAdd}>
          + Add
        </button>
      </div>

      {/* Active Filters */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {filters.map((f, i) => (
          <div
            key={i}
            style={{
              background: "#e6fffa",
              padding: "4px 10px",
              borderRadius: 20,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {f.label}: {f.value}
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => removeFilter(i)}
            >
              ×
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}